var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('h1',[_vm._v(_vm._s(_vm.$t('tag-manager')))])]),_c('div',{staticClass:"col-md-3"},[_c('router-link',{staticClass:"btn btn-primary btn-block btn-lg mb-3",attrs:{"to":"/settings/tag"}},[_vm._v(" "+_vm._s(_vm.$t('new-tag'))+" ")])],1)]),_c('Table',{attrs:{"loading":_vm.loading,"submitting":_vm.submitting,"cols":[
                { key: 'name', heading: _vm.$t('name'), size: 6 },
                { key: 'taggroup_id', heading: _vm.$t('tag-group-name'), size: 6,
                    cb: tag => {
                        const match = _vm.taggroups.find(obj => obj.id == tag.taggroup_id);
                        if(match){
                            const name = match.name;
                            return name
                        } else {
                            return ;
                        }

                    }
                }
            ],"data":_vm.tags,"breakpoint":"md","filters":{
                ..._vm.filters,
                page: _vm.filters.page,
                page_size: _vm.filters.page_size,
            },"searchable":true,"scrollPaginate":true},on:{"refresh":_vm.refresh,"selectItem":tag => _vm.$router.push(`/settings/tag/${tag.id}`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }